module.exports = __webpack_public_path__ + "img/ic_services_babysitting.1894087b.svg";